module.exports = __webpack_public_path__ + "static/media/St Albans Wardrobes (2).f2e44831.jpg";